export default __webpack_public_path__ + "static/media/commentNote.020e18d0.svg";